import React from "react";
import { motion } from "framer-motion";
import { Container, Overline } from "./common";

export const PageHero = ({ overline, title, subtitle, image }) => (
  <section className="relative pt-[74px] bg-navy overflow-hidden" data-testid="page-hero">
    <div className="absolute inset-0">
      <img src={image} alt="" className="h-full w-full object-cover opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-b from-navy/80 via-navy/70 to-teal-900/90" />
      <div className="absolute inset-0 grain opacity-[0.08]" />
    </div>
    <Container className="relative py-20 lg:py-28">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-3xl"
      >
        <Overline light>{overline}</Overline>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mt-5 leading-[1.05] tracking-tight text-balance">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-lg text-teal-100/90 leading-relaxed max-w-2xl">{subtitle}</p>}
      </motion.div>
    </Container>
  </section>
);
